export const PAGES_MENU = [
  {

    path: 'dashboard',
    data: {
      menu: {
        title: 'Dashboard',
        icon: 'fa fa-home',
        selected: false,
        expanded: false,
        order: 0
      }
    }
  },

  {
    path: 'mobile',
    data: {
      menu: {
        title: 'Mobile',
        icon: 'fa fa-mobile',
        selected: false,
        expanded: false,
        order: 250,
      }
    },
    children: [
      {
        path: 'movements',
        data: {
          menu: {
            title: 'Movimentos',
            icon: 'fa fa-file-video-o'
          }
        }
      }
    ]
  },

  {
    path: 'backoffice',
    data: {
      menu: {
        title: 'Backoffice',
        icon: 'fa fa-desktop',
        selected: false,
        expanded: false,
        order: 250,
      }
    },
    children: [
      {
        path: 'announcements',
        data: {
          menu: {
            title: 'Anúncios',
            icon: 'fa fa-file-o'
          }
        }
      },
      {
        path: 'announcementItems',
        data: {
          menu: {
            title: 'Linhas de Anúncios',
            icon: 'fa fa-file-o'
          }
        }
      },
      {
        path: 'movements',
        data: {
          menu: {
            title: 'Movimentos',
            icon: 'fa fa-arrows'
          }
        }
      }
    ]
  },

  {
    path: 'customer',
    data: {
      menu: {
        title: 'Cliente',
        icon: 'fa fa-desktop',
        selected: false,
        expanded: false,
        order: 250,
      }
    },
    children: [
      {
        path: 'dayMovementsResume',
        data: {
          menu: {
            title: 'Mov. Resumo',
            icon: 'fa fa-file-o'
          }
        }
      },
      {
        path: 'dayMovementsDetail',
        data: {
          menu: {
            title: 'Mov. Detalhe',
            icon: 'fa fa-file-o'
          }
        }
      },
      {
        path: 'loadtruck',
        data: {
          menu: {
            title: 'Guias',
            icon: 'fa fa-file-o'
          }
        }
      }

    ]
  },

  {
    path: 'config',
    data: {
      menu: {
        title: 'Configuração',
        icon: 'fa fa-cogs',
        selected: false,
        expanded: false,
        order: 400,
      }
    },
    children: [
      {
        path: 'customertypes',
        data: {
          menu: {
            title: 'Tipos de cliente',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'customers',
        data: {
          menu: {
            title: 'Clientes',
            icon: 'fa fa-users'
          }
        }
      },
      {
        path: 'truckingcompanies',
        data: {
          menu: {
            title: 'Camionagem',
            icon: 'fa fa-truck'
          }
        }
      },
      {
        path: 'vesselandprocesses',
        data: {
          menu: {
            title: 'Navios',
            icon: 'fa fa-ship'
          }
        }
      },
      {
        path: 'producttypes',
        data: {
          menu: {
            title: 'Tipos de produto',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'damages',
        data: {
          menu: {
            title: 'Avarias',
            icon: 'fa fa-file-video-o',
          }
        }
      },
      {
        path: 'templates',
        data: {
          menu: {
            title: 'Templates',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'zones',
        data: {
          menu: {
            title: 'Zonas',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'producttypeZoneDamages',
        data: {
          menu: {
            title: 'Avarias por TP + Zona',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'users',
        data: {
          menu: {
            title: 'Utilizadores',
            icon: 'fa fa-user'
          }
        }
      },
      {
        path: 'qrcodesrules',
        data: {
          menu: {
            title: 'Regras QR Codes',
            icon: 'fa fa-user'
          }
        }
      },
      {
        path: 'configurations',
        data: {
          menu: {
            title: 'Configurações',
            icon: 'fa fa-user'
          }
        }
      }
    ]
  },

  {
    path: 'maps',
    data: {
      menu: {
        title: 'Mapas',
        icon: 'fa fa-file-text-o',
        selected: false,
        expanded: false,
        order: 400,
      }
    },
    children: [
      {
        path: 'loadtruck',
        data: {
          menu: {
            title: 'Guia de Carga',
            icon: 'fa fa-sitemap',
          }
        }
      },
      {
        path: 'reports',
        data: {
          menu: {
            title: 'Relatórios',
            icon: 'fa fa-file-video-o',
          }
        }
      },
      {
        path: 'dayMovementsResume',
        data: {
          menu: {
            title: 'Mov. Resumo',
            icon: 'fa fa-file-o'
          }
        }
      },
      {
        path: 'dayMovementsDetail',
        data: {
          menu: {
            title: 'Mov. Detalhe',
            icon: 'fa fa-file-o'
          }
        }
      }     
    ]
  }

];



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/app.menu.ts